import { Link } from 'react-router-dom';

interface LandingNavbarProps {
  onCtaClick?: () => void;
}

const navItems = ['How it works', 'Payroll & NIB', 'Pricing', 'Blog'];

export function LandingNavbar({ onCtaClick }: LandingNavbarProps) {
  return (
    <nav
      className="sticky top-0 z-50 flex items-stretch h-20 bg-soft-paper/90 backdrop-blur-md"
      style={{ borderBottom: 'var(--border-medium)' }}
    >
      {/* Brand */}
      <div
        className="w-[280px] px-6 font-display text-2xl font-bold text-indigo-600 flex items-center shrink-0"
        style={{ borderRight: 'var(--border-light)' }}
      >
        Paradigm.
      </div>

      {/* Nav Links */}
      <div className="flex flex-1">
        {navItems.map((item) => (
          <a
            key={item}
            href={`#${item.toLowerCase().replace(/\s+&\s+/g, '-').replace(/\s+/g, '-')}`}
            className="px-8 flex items-center text-[0.95rem] font-medium text-gray-600 hover:text-indigo-600 hover:bg-indigo-600/[0.04] transition-all duration-200 cursor-pointer whitespace-nowrap"
            style={{ borderRight: 'var(--border-light)' }}
          >
            {item}
          </a>
        ))}
      </div>

      {/* CTA */}
      <Link
        to="/register"
        onClick={onCtaClick}
        className="w-[280px] bg-indigo-600 text-white flex items-center justify-center font-semibold hover:bg-indigo-700 hover:-translate-y-px transition-all duration-200 shrink-0"
      >
        Create Free Account
      </Link>
    </nav>
  );
}
